import { Settings } from './interfaces/interfaces';
import { main } from './main';

/**
 * Allows to TypeScript recognize library namespace
 */
declare global {
  interface Window {
    nature: any;
  }

  interface HTMLElement {
    jso: any;
  }
}

/**
 * Nature Kit WebGL Library
 * @param {string} settings
 *
 * Usage examples:
 * -----------------
 * nature();
 * window.nature();
 * window.nature({ ...settings... });
 */
window.nature = (settings: Settings) => {
  
  // ensure settings object
  settings = settings || {} as Settings;

  // loop though nature placeholders
  const $boxes = document.querySelectorAll('[data-nature]') as NodeListOf<HTMLElement>;
  for(let i=0; i<$boxes.length; i++) {

    const $box = $boxes[i];

    const type = $box.getAttribute('data-nature');
    if(!type) continue;

    if($box.jso && $box.jso.nature) {
      $box.jso.nature.removeListeners();
    }

    // save APIs object in the DOM for the future reference
    const api = main(settings, $box, type);
    $box.jso = $box.jso || {};
    $box.jso.nature = api;
  }
};
